import React from "react";
import PageSection from "src/components/Dashboards/DashboardSection";

const pages = () => {
  return <PageSection />;
};

export default pages;
